var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 788.83,
    height: 759.304,
    viewBox: "0 0 788.83 759.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(634.572 -340.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M154.258,425.987,20.913,523.279Q9.686,492.061-18.729,492.044q-36.036,0-37.591,47.638h.41v72.106H-2.326V758.359H-55.91v175q0,73.661-44.426,120.12-44.494,46.442-114.96,46.476-84.888,0-129.723-77.3-27.681,41.623-59.291,59.462-31.628,17.839-78.087,17.838-73.713,0-112.944-46.476-39.215-46.442-39.231-133.755V539.682h162.6V895.293q0,26.451,4.2,34.857t17.019,8.407q23.99,0,24.024-40.462V539.682h162.6V895.293q0,25.63,4.408,34.447,4.357,8.817,17.224,8.817,22.349,0,23.922-37.625h-.41V561.724q0-8.971.513-17.634c.1-1.5.2-2.939.308-4.408q6.1-81.043,58.266-136.353,59.052-62.64,148.758-62.674Q87.79,340.655,154.258,425.987Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.a706de539ca413cc95bf80a22d7afff0.svg";
export { ForwardRef as ReactComponent };